<form [formGroup]="form">
  <div class="row">
    <div class="form-group">
      <label>{{ 'user.given_name' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['given_name']"></app-input-with-error>
    </div>
  </div>
  <div class="row">
    <div class="form-group">
      <label>{{ 'user.family_name' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['family_name']"></app-input-with-error>
    </div>
  </div>
  <div class="row">
    <div class="form-group">
      <label>{{ 'user.email' | translate }}</label> <label style="color: #5d666f; font-size: small;" class="mx-1">(optional)</label>
      <app-input-with-error [control]="this.form.controls['email']"></app-input-with-error>
    </div>
  </div>
  <div class="row">
    <div class="form-group">
      <label>{{ 'worker.assignedWorkflow' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['assignedWorkflowId']" [inputType]="'select'" [translateSelect]="false" [selectValues]="workflowIds" [selectNames]="workflowNames" [selectDefaultText]="'worker.assignedWorkflow_hint' | translate"></app-input-with-error>
    </div>
  </div>
  <div class="row">
    <div class="form-group">
      <label>{{ 'worker.assignedIdleWorkflow' | translate }}</label> <label style="color: #5d666f; font-size: small;" class="mx-1">(optional)</label>
      <app-input-with-error [control]="this.form.controls['assignedIdleWorkflowId']" [inputType]="'select'" [translateSelect]="false" [selectValues]="idleWorkflowIdsWithEmpty" [selectNames]="idleWorkflowNamesWithEmpty" [selectDefaultText]="'worker.assignedIdleWorkflow_default' | translate" [selectDefaultIsDisabled]="false" ></app-input-with-error>
    </div>
  </div>
  <div class="row">
    <div class="form-group">
      <label>{{ 'worker.additionalData' | translate }}</label> <label style="color: #5d666f; font-size: small;" class="mx-1">(optional)</label>
      <app-input-with-error [control]="this.form.controls['additionalData']"></app-input-with-error>
    </div>
  </div><div class="row">
    <div class="form-group">
      <app-input-with-error [control]="this.form.controls['usesDraftWorkflowDefinition']" [inputType]="'checkbox'" [description]="'worker.use-draft-definition'"></app-input-with-error>
    </div>
  </div>
  <div class="row">
    <div class="form-group">
      <app-input-with-error
        [control]="this.form.controls['shouldUpdateDeviceOrganization']"
        [inputType]="'checkbox'"
        [description]="'worker.shouldUpdateDeviceOrganization.label'">
      </app-input-with-error>
      <div class="form-text ms-3 text-muted small">{{ 'worker.shouldUpdateDeviceOrganization.description' | translate }}</div>
    </div>
  </div>
  <app-error [error]="error"></app-error>
</form>
